import {
  Autocomplete,
  Box,
  FormControl,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { JiraConfigureTicketAction } from "../../../../utils/constants";

const JSMConfigureTicket = ({ jiraState, action }) => {
  const colors = useColors();

  return (
    <>
      {jiraState.projectOptions && (
        <Autocomplete
          options={jiraState.projectOptions}
          disabled={jiraState.loadedFields["projects"] === false}
          getOptionLabel={(option) => option.name}
          value={jiraState.selectedProject}
          onChange={(event, newValue) => jiraState.setSelectedProject(newValue)}
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1">Project name</Typography>
                  <Typography variant="body1" color="error" sx={{ ml: 1 }}>
                    *
                  </Typography>
                </Box>
              }
              fullWidth
            />
          )}
        />
      )}

      <Autocomplete
        options={jiraState.assigneeOptions}
        getOptionLabel={(option) => option?.displayName || option}
        value={jiraState.reporterName}
        disabled={jiraState.loadedFields["assignees"] === false}
        onChange={(event, newValue) =>
          jiraState.setReporterName(newValue?.displayName)
        }
        PopperComponent={({ children, ...props }) => {
          const { anchorEl } = props;
          const width = anchorEl ? anchorEl.offsetWidth : undefined;
          return (
            <Popper {...props} style={{ minWidth: width }}>
              {children}
            </Popper>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            label="Raise this request on behalf of"
            fullWidth
          />
        )}
      />

      {(action === JiraConfigureTicketAction.CREATE ||
        action === JiraConfigureTicketAction.EDIT) && (
        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              autoFocus
              margin="dense"
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1">Summary</Typography>
                  <Typography variant="body1" color="error" sx={{ ml: 1 }}>
                    *
                  </Typography>
                </Box>
              }
              fullWidth
              value={jiraState.incidentSummary}
              onChange={(e) => jiraState.setIncidentSummary(e.target.value)}
            />
          </Box>
        </>
      )}

      {jiraState.incidentTypes && (
        <Autocomplete
          options={jiraState.incidentTypes}
          value={jiraState.selectedIncidentType}
          onChange={(event, newValue) =>
            jiraState.setSelectedIncidentType(newValue)
          }
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1">Incident type</Typography>
                  <Typography variant="body1" color="error" sx={{ ml: 1 }}>
                    *
                  </Typography>
                </Box>
              }
              fullWidth
            />
          )}
        />
      )}

      {jiraState.incidentPriorities && (
        <Autocomplete
          options={jiraState.incidentPriorities}
          value={jiraState.selectedIncidentPriority}
          onChange={(event, newValue) =>
            jiraState.setSelectedIncidentPriority(newValue)
          }
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1">Priority</Typography>
                  <Typography variant="body1" color="error" sx={{ ml: 1 }}>
                    *
                  </Typography>
                </Box>
              }
              fullWidth
            />
          )}
        />
      )}

      {(action === JiraConfigureTicketAction.CREATE ||
        action === JiraConfigureTicketAction.EDIT) && (
        <>
          <FormControl fullWidth sx={{ mt: 2 }}>
            {/* Floating Label Positioned Above the Border */}
            <Box
              sx={{
                position: "relative",
                display: "inline-block",
                width: "400px",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: "-10px",
                  left: "10px",
                  backgroundColor: colors.background_dialog, // Matches background to hide border
                  padding: "0 5px",
                  fontWeight: 500,
                  fontSize: "12px",
                  color: colors.black_48percent,
                }}
              >
                Description
              </Typography>

              {/* Quill Editor with a Styled Border */}
              <Box
                sx={{
                  border: "none", // Remove the border
                  borderRadius: "5px",
                  "& .ql-toolbar": { borderBottom: "1px solid #ccc" }, // Ensures toolbar is visible
                  "& .ql-container": {
                    minHeight: "100px", // Set min height for the editor
                    maxHeight: "200px", // Set max height for the editor
                    overflowY: "auto", // Enable vertical scrolling
                    overflowX: "auto",
                    minWidth: "400px",
                  },
                }}
              >
                <ReactQuill
                  theme="snow"
                  value={jiraState.incidentDescription}
                  onChange={jiraState.setIncidentDescription}
                />
              </Box>
            </Box>
          </FormControl>
        </>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {action === JiraConfigureTicketAction.CONFIGURE && (
          <PrimaryButton
            onClick={jiraState.handleSaveIssueConfig}
            style={{ textTransform: "none" }}
          >
            Save Configuration
          </PrimaryButton>
        )}
      </div>
    </>
  );
};
export default JSMConfigureTicket;
